export default __webpack_public_path__ + "static/Century_Gothic_It-e83c4a0cb07a4f8ebeb0063e116ee298.woff2";